<section class="hero wave-bg" style="background: linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(/assets/case-modernization.jpg) center/cover;">
  <div class="container hero-content">
    <div class="hero-text">
      <div style="color: #ff4757; font-weight: 700; margin-bottom: 1rem; text-transform: uppercase; letter-spacing: 0.1em;">Intervention d'Urgence Technique</div>
      <h1>
        Votre plateforme Node.js est instable ? 
        <span class="accent"> Reprenez le contrôle sous 24 heures.</span>
      </h1>
      <p class="hero-description">
        Ne laissez pas une instabilité technique détruire votre chiffre d'affaires et la confiance de vos clients. Crashs serveurs répétitifs, lenteurs inexpliquées ou dettes techniques accumulées : nos architectes seniors stabilisent vos environnements de production immédiatement.
      </p>
      <div class="cta-row">
        <a 
          href="https://cal.mesh-box.fr/ogirodin/30min"
          target="_blank"
          rel="noopener"
          class="button primary large" 
          style="background: #ff4757; color: white; border-color: #ff4757;"
        >
          🚨 Activer l'Intervention d'Urgence
        </a>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container max-w-5xl">
    <h2 class="text-center mb-12">Nos domaines d'intervention critique Node.js</h2>
    <div class="grid-3 gap-8">
      <div class="card p-8 border-t-4 border-red-500 shadow-lg">
        <h4 class="text-xl font-bold mb-4">Memory Leaks & ANR</h4>
        <p class="text-sm">Analyse approfondie des heaps dumps et profilage du moteur V8. Nous identifions la source exacte des fuites de mémoire pour stopper les redémarrages incessants de vos conteneurs.</p>
      </div>
      <div class="card p-8 border-t-4 border-red-500 shadow-lg">
        <h4 class="text-xl font-bold mb-4">Optimisation des I/O</h4>
        <p class="text-sm">Identification du code synchrone bloquant la boucle d'événements (Event Loop). Nous réécrivons vos flux asynchrones pour une fluidité maximale et des temps de réponse records.</p>
      </div>
      <div class="card p-8 border-t-4 border-red-500 shadow-lg">
        <h4 class="text-xl font-bold mb-4">Sécurisation Post-Audit</h4>
        <p class="text-sm">Intervention immédiate après une compromission. Nous auditons vos dépendances (npm audit), colmatons les brèches et renforçons vos middlewares de sécurité.</p>
      </div>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-4xl text-center">
    <h2>Cessez de subir votre technique, commencez à stabiliser</h2>
    <p class="text-lg mb-8">
      Beaucoup d'équipes techniques s'épuisent dans un cycle sans fin de correctifs temporaires. Notre mission est de vous en sortir définitivement. Après chaque intervention d'urgence, nous remettons un rapport détaillé incluant un <strong>Plan de Stabilisation Durable</strong>.
    </p>
    <div class="grid-2 gap-12 text-left items-center">
      <div>
        <h3 class="mb-4">Un audit flash actionnable</h3>
        <p class="mb-6">Nous analysons votre architecture logicielle, vos requêtes base de données et votre infrastructure pour déceler les risques invisibles. Notre audit n'est pas théorique, il est conçu pour être appliqué immédiatement par vos équipes.</p>
        <app-cii-badge variant="inline" />
      </div>
      <div class="bg-card p-8 rounded-xl border border-brand/20">
        <h4 class="mb-4">Vos bénéfices immédiats</h4>
        <ul class="check-list space-y-2">
          <li><strong>Uptime de 99.9%</strong> retrouvé sur vos serveurs.</li>
          <li><strong>Divisez par 3</strong> vos coûts de maintenance curative.</li>
          <li>Libérez vos développeurs pour l'<strong>innovation</strong>.</li>
          <li><strong>Crédit Impôt Innovation :</strong> récupérez 20% des frais.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container max-w-4xl text-center">
    <h2>Intervention par des Experts Seniors uniquement</h2>
    <p class="mb-10 text-lg">Dans une situation critique, vous n'avez pas besoin d'un stagiaire mais d'un architecte chevronné qui a déjà géré des parcs de milliers d'instances Node.js.</p>
    <div class="flex justify-center gap-10 flex-wrap">
      <div class="text-center">
        <div class="text-4xl font-bold text-brand mb-2">24h</div>
        <p class="text-xs uppercase tracking-widest text-muted">Délai d'intervention</p>
      </div>
      <div class="text-center">
        <div class="text-4xl font-bold text-brand mb-2">+10 ans</div>
        <p class="text-xs uppercase tracking-widest text-muted">Expérience moyenne</p>
      </div>
      <div class="text-center">
        <div class="text-4xl font-bold text-brand mb-2">100%</div>
        <p class="text-xs uppercase tracking-widest text-muted">Made in France</p>
      </div>
    </div>
  </div>
</section>

<section class="section cta-final alt">
  <div class="container text-center">
    <h2>Besoin d'un diagnostic expert Node.js maintenant ?</h2>
    <p class="text-lg mb-8">Ne perdez plus une seconde. Parlez directement à un architecte senior pour évaluer la situation et lancer l'intervention.</p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
      <a 
        href="https://cal.mesh-box.fr/ogirodin/30min"
        target="_blank"
        rel="noopener"
        class="button primary large" 
      >
        📞 Parler à un Expert Senior (Visio)
      </a>
      <a routerLink="/contact" class="button large outline">Formulaire de Contact</a>
    </div>
    <br/>
    <a routerLink="/maintenance-tma-nodejs-angular" style="display: inline-block; margin-top: 1.5rem; color: var(--brand); font-weight: bold;">
      ← Voir toutes nos offres de maintenance
    </a>
  </div>
</section>